import Vue from "vue";

import {
  titleize,
  pluralize,
  humanize,
  underscore,
  dasherize,
  capitalize,
  formatDecimal,
  formatPercentage,
  formatDateTime,
  formatCurrency,
  prepareTimezone
} from "./helpers";

Vue.filter("capitalize", capitalize);
Vue.filter("titleize", titleize);
Vue.filter("underscore", underscore);
Vue.filter("humanize", humanize);
Vue.filter("pluralize", pluralize);
Vue.filter("dasherize", dasherize);
Vue.filter("formatDecimal", formatDecimal);
Vue.filter("formatPercentage", formatPercentage);

Vue.filter("formatDate", function (value, forceUtc = false, timezone) {
  return prepareTimezone(Vue.prototype.$dayjs, value, forceUtc, timezone).toLocaleString("en-US", {
    weekday: "short", year: "numeric", month: "short", day: "numeric"
  });
});

Vue.filter("formatDateInNumeric", function (value, forceUtc = false, timezone) {
  return prepareTimezone(Vue.prototype.$dayjs, value, forceUtc, timezone).toLocaleString("en-GB", {
    year: "numeric", day: "numeric", month: "numeric"
  });
});

Vue.filter("formatTime", function (value, forceUtc = false, timezone) {
  return prepareTimezone(Vue.prototype.$dayjs, value, forceUtc, timezone).toLocaleString("en-US", {
    hour: "numeric", minute: "numeric", hour12: false
  });
});

Vue.filter("formatDateTime", function (value, forceUtc = false, timezone) {
  return formatDateTime(Vue.prototype.$dayjs, value, forceUtc, timezone);
});

Vue.filter("formatCurrency", function (value, currency, minimumFractionDigits = 2) {
  return formatCurrency(value, currency, minimumFractionDigits);
});

Vue.filter("formatDiscountAmount", function (value, percentage, currency) {
  return percentage ? formatPercentage(value) : formatCurrency(value, currency);
});
